import es from "./default/es.json";
import en from "./default/en.json";
import ca from "./default/ca.json";
import Storage from "@storage";
import Languages from "@shared/types/enums/languages";

interface TranslationSheet {
  [key: string]: string | TranslationSheet;
}

class TranslationManagerClass {
  currentLanguage: Languages;
  sheets: TranslationSheet;
  callback?: ((ev: (prev: boolean) => boolean) => void) | null;
  values: {
    es: string;
    en: string;
    ca: string;
  };

  constructor() {
    this.currentLanguage = (Storage.get("language") as Languages) || 'es';
    this.sheets = {
      es: es,
      en: en,
      ca: ca,
    };
    this.values = {
      es: "Español",
      en: "English",
      ca: "Català",
    };
  }

  setLanguage(newLanguage:  Languages, addToStorage = true) {
    this.currentLanguage = newLanguage;
    if(addToStorage) Storage.set("language", newLanguage);
    if (this.callback)
      this.callback((previous: boolean) => {
        return !previous;
      });
  }

  setChangeListener(callback: (ev: (prev: boolean) => boolean) => void) {
    this.callback = callback;
  }

  removeChangeListener() {
    this.callback = null;
  }

  get(
    key: string,
    param1?: string,
    param2?: string,
    param3?: string,
    param4?: string,
    param5?: string
  ): string {
    try {
      let parsedValue = "";
      let splittedKeys: string[] = [];
      splittedKeys = key.split(".");
      let finalKey: any;
      finalKey = this.sheets[this.currentLanguage];
      let keyIndex = 0;
      do {
        const keyToEvaluate: string = splittedKeys[keyIndex] as string;
        finalKey = finalKey[keyToEvaluate];
        keyIndex++;
      } while (keyIndex !== splittedKeys.length);
      parsedValue = finalKey
        .replace("{param1}", param1)
        .replace("{param2}", param2)
        .replace("{param3}", param3)
        .replace("{param4}", param4)
        .replace("{param5}", param5);
      return parsedValue;
    } catch {
      return key;
    }
  }

  getFromLanguage(language: Languages, key: string, 
    param1?: string,
    param2?: string,
    param3?: string,
    param4?: string) {
      try {
        let parsedValue = "";
        let splittedKeys: string[] = [];
        splittedKeys = key.split(".");
        let finalKey: any;
        finalKey = this.sheets[language];
        let keyIndex = 0;
        do {
          const keyToEvaluate: string = splittedKeys[keyIndex] as string;
          finalKey = finalKey[keyToEvaluate];
          keyIndex++;
        } while (keyIndex !== splittedKeys.length);
        parsedValue = finalKey
          .replace("{param1}", param1)
          .replace("{param2}", param2)
          .replace("{param3}", param3)
          .replace("{param4}", param4);
        return parsedValue;
      } catch {
        return key;
      }

    }
}

const TranslationManager = new TranslationManagerClass();
export default TranslationManager;
